import React, { Fragment } from 'react'
import { Redirect } from 'react-router-dom'
import { pathOr } from 'ramda'
import { formatCurrency } from '../../utils/utils'
import GetStarted from '../../components/GetStarted'
import Header from '../Header'

import './ThankYou.css'

const mapDropoff = {
  'Leave with doorman': 'leave $ with the doorman',
  'Deliver to my door': 'delivery $ to your door',
  'Leave at my door': 'leave $ at your door'
}

const ThankYou = props => {
  const {
    orderConfirmation,
    selectedDeliveryDay,
    selectedDeliveryTime,
    selectedAddress,
    selectedDropoff
  } = props

  if (!orderConfirmation) {
    return <Redirect to="/" />
  }

  const items = pathOr([], ['items'], orderConfirmation)
  const coupon = pathOr('', ['coupon'], orderConfirmation)
  const subtotal = formatCurrency(pathOr(0, ['subtotal'], orderConfirmation))
  const shipping = formatCurrency(pathOr(0, ['shipping'], orderConfirmation))
  const taxes = formatCurrency(pathOr(0, ['taxes'], orderConfirmation))
  const discount = formatCurrency(pathOr(0, ['discount'], orderConfirmation))
  // const tip = formatCurrency(pathOr(0, ['tip'], orderConfirmation))
  const grandTotal = formatCurrency(
    pathOr(0, ['grandTotal'], orderConfirmation)
  )

  const hasDiscount = !!pathOr(0, ['discount'], orderConfirmation)

  const discountLabel = coupon
    ? `Your discount (${coupon.toUpperCase()})`
    : 'Your discount'

  const deliveryDay = pathOr('', ['label'], selectedDeliveryDay)
  const deliveryTime = pathOr('', ['label'], selectedDeliveryTime)

  const address = pathOr('', ['label'], selectedAddress)

  const orderMealCount = items.length

  const dropoff = mapDropoff[selectedDropoff].replace(
    '$',
    orderMealCount > 1 ? 'them' : 'it'
  )

  return (
    <Fragment>
      <Header />
      <div className="cookunity__thankyou_container">
        <div className="cookunity__thankyou">
          <h1 className="heading">
            Thank You.
            <br />
            Get ready <span>to enjoy!</span>
          </h1>

          <div className="details_container">
            <div className="detail_section">
              <h2 className="title">Order Summary</h2>
              <p>
                You just ordered <strong>{orderMealCount} meals</strong> á la
                carte.
              </p>
              <p>
                You will be charged {subtotal} + Delivery Fee {shipping} + Taxes{' '}
                {taxes}
                {/* Tip{' '} {tip}  */}
              </p>
              {hasDiscount && (
                <p className="discount">
                  {discountLabel}: {discount}
                </p>
              )}
              <div className="total">
                <p>Your order total is:</p>
                <p className="grand_total">{grandTotal}</p>
              </div>
            </div>

            <div className="detail_section">
              <h2 className="title">Delivery</h2>
              <p>
                Your {orderMealCount > 1 ? 'meals' : 'meal'} will arrive on:
              </p>
              <p className="delivery_detail">
                {deliveryDay} from {deliveryTime.replace('-', 'to')}
              </p>
              <p>at this address:</p>
              <p className="delivery_detail">{address}</p>
              <p>We will {dropoff}.</p>
            </div>
          </div>

          <GetStarted large style={{ marginTop: 40 }} />
        </div>
      </div>
    </Fragment>
  )
}

export default ThankYou



// WEBPACK FOOTER //
// ./src/modules/ThankYou/ThankYou.jsx